import React from 'react';
import * as Styled from './OTextBlockEditorial.styles';
import type { OTextBlockEditorialProps } from './OTextBlockEditorial.types';
import { MTextBlockEditorial } from '../../molecules/MTextBlockEditorial';

const COMPONENT_NAME = 'o-web-ui-kit-OTextBlockEditorial';
const TEST_ID = 'web-ui-kit-OTextBlockEditorial';

export const OTextBlockEditorial = React.forwardRef<HTMLDivElement, OTextBlockEditorialProps>((props, ref) => {
  const { className, mTextBlockEditorialMulti: blocksProp, trackingProperties: trackingProp, ...rest } = props;
  const model = (props.model || {}) as Record<string, unknown>;
  const mTextBlockEditorialMulti =
    blocksProp ?? (model['mTextBlockEditorialMulti'] as OTextBlockEditorialProps['mTextBlockEditorialMulti']) ?? [];
  const trackingProperties =
    trackingProp ?? (model['trackingProperties'] as OTextBlockEditorialProps['trackingProperties']);

  return (
    <Styled.Container
      ref={ref}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      className={className}
      {...rest}
    >
      {mTextBlockEditorialMulti.map((block, index) => (
        <Styled.BlockWrapper key={index}>
          <MTextBlockEditorial {...block} trackingProperties={trackingProperties} />
        </Styled.BlockWrapper>
      ))}
    </Styled.Container>
  );
});

OTextBlockEditorial.displayName = 'OTextBlockEditorial';
